export default {
  featuredArticlesTitle: {
    id: 'hub_buying_guide_featured_title',
    defaultMessage: 'Most popular articles',
  },
} as const
